export const isLocalHostname = (hostname) => (
  hostname === 'localhost'
  || hostname === '127.0.0.1'
  || hostname === '::1'
);

export const canUseLocalTestLogin = ({
  nodeEnv = process.env.NODE_ENV,
  enabled = process.env.REACT_APP_ENABLE_TEST_LOGIN,
  hostname = window.location.hostname,
} = {}) => (
  nodeEnv === 'development'
  && enabled === 'true'
  && isLocalHostname(hostname)
);
